import { Maximize2, Minimize2 } from 'lucide-react'

/**
 * Shared Expand/Collapse control for the corner of an expandable panel's
 * header. Presentational only — state lives in useExpandablePanel.
 */
export function ExpandToggle({
  expanded,
  onToggle,
}: {
  expanded: boolean
  onToggle: () => void
}) {
  return (
    <button
      type="button"
      className="expand-toggle focus-ring"
      onClick={onToggle}
      aria-expanded={expanded}
      aria-label={expanded ? 'Collapse panel' : 'Expand panel'}
      title={expanded ? 'Collapse' : 'Expand'}
    >
      {expanded ? <Minimize2 size={14} /> : <Maximize2 size={14} />}
    </button>
  )
}
